module.exports = __webpack_public_path__ + "img/logo-full.274faa60.png";